import { Tooltip, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import EditClient from "../../icons/EditClient";
import FMUInputField from "../shared/FormIkMUFormComponent/FMUInputField";
import { Field } from "formik";
import InputMask from "react-input-mask";
import { tokens } from "../../theme/tokens";

// const useStyle = makeStyles((theme) => ({
//   caseContainer: {
//     // width: "928px",
//     width: "98%",
//     paddingLeft: "2%",
//     [theme.breakpoints.down("md")]: {
//       width: "90%",
//     },
//   },
//   topBar: {
//     height: "50px",
//     backgroundColor: "#f8f8f8",
//     padding: "0 2% 0 2%",
//     display: "flex",
//     alignItems: "center",
//   },
//   heading: {
//     fontSize: "1.2em",
//     color: "#0097bb",
//     //fontWeight: "bold",
//   },
//   parent: {
//     justifyContent: "space-between",
//     flexDirection: "row",
//     flexWrap: "wrap",
//     display: "flex",
//     paddingRight: "2%",
//     marginTop: "2vh",
//   },
//   parentChild: {
//     flex: "1",
//     width: "40%",
//     "&:nth-child(1)": {
//       paddingRight: "5vh",
//     },
//     "&:nth-child(2)": {
//       paddingLeft: "5vh",
//     },
//   },
//   rowContainer: {
//     display: "flex",
//     marginTop: "8px",
//   },
//   labelContainer: {
//     display: "flex",
//     width: "50%",
//     alignItems: "center",
//     "& p": {
//       fontSize: "1em",
//       // fontWeight:"bold",
//       color: tokens.color.text.primary,
//     },
//   },
//   fieldContainer: {
//     width: "50%",
//   },
//   postButton: {
//     height: "40px",
//     marginTop: "20px",
//     width: "160px",
//     color: tokens.color.brand.onPrimary,
//     backgroundColor: "#0097bb",
//     //fontWeight: "bold",
//     textTransform: "capitalize",
//     // border: "1px solid #3C72D9",
//     borderRadius: tokens.radius.md,
//     fontSize: "1.2em",
//     "&:hover": {
//       backgroundColor: "#0097bb",
//       opacity: "0.8",
//     },
//     "&.Mui-disabled": {
//       backgroundColor: tokens.color.surface.subtle,
//       color: tokens.color.brand.onPrimary,
//     },
//   },
//   input: {
//     width: "95%",
//     border: `1px solid ${tokens.color.border.default}`,
//     "& .MuiInputBase-input": {
//       textIndent: "10px",
//     },
//     borderRadius: tokens.radius.sm,
//     height: "40px",
//     paddingLeft: "3px",
//     backgroundColor: "#f8f8f8",
//   },
//   subjectButton: {
//     // padding:"0.5vh 3vh 0.5vh 3vh",
//     width: "160px",
//     color: tokens.color.brand.onPrimary,
//     //fontWeight: "bold",
//     textTransform: "capitalize",
//     backgroundColor: tokens.color.brand.primaryAction,
//     // border: "1px solid #3C72D9",
//     borderRadius: tokens.radius.sm,
//     fontSize: "1.1em",
//     "&:hover": {
//       backgroundColor: tokens.color.brand.primaryAction,
//       opacity: "0.8",
//     },
//   },
//   buttonRow: {
//     display: "flex",
//     flexDirection: "row-reverse",
//     columnGap: "15px",
//     marginTop: "1vh",
//   },
//   buttonRowTabButton: {
//     boxShadow: "none",
//     backgroundColor: "#f8f8f8",
//     borderRadius: tokens.radius.sm,
//     textTransform: "capitalize",
//   },

//   invoiceDetailsTable: {
//     width: "100%",
//     textAlign: "left",
//     color: "#4e4e4e",
//     borderCollapse: "collapse",
//     borderSpacing: "0 15px",
//     fontSize: "1em",
//     // maxWidth:"fit-content",
//     // overflow: "visible",
//     // display: "block",
//     // overflowX: "auto",
//     whiteSpace: "nowrap",
//   },
//   clientthtr: {
//     backgroundColor: "#f8f8f8",
//     borderRadius: tokens.radius.md,
//     paddingTop: "5px",
//     height: "30px",
//   },

//   tableTd: {
//     height: "30px",
//     paddingLeft: "30px",
//     whiteSpace: "nowrap",
//     border: "1px solid",
//     borderCollapse: "collapse",
//     borderSpacing: "0px",
//     // paddingLeft:"5px",
//     // paddingRight:"15px"
//     // textIndent:"15px"
//     //borderBottom:"1px solid #e8e8e8",fontSize: "1em",color: "rgb(78, 78, 78)",// fontWeight:"bold",paddingTop:"30px"
//   },
//   tableTh: {
//     textAlign: "left",
//     // paddingLeft: "10px",
//     whiteSpace: "nowrap",
//     wordWrap: "break-word",
//     width: "40px",
//   },
//   tableThEmpty: {
//     width: "10px",
//   },
//   wrap: {
//     // whiteSpace: "nowrap"
//   },
//   actionButton: {
//     backgroundColor: theme.palette.primary.main,
//     // fontFamily: "poppins",
//     //fontWeight: "bold",
//     fontSize: ".8em",
//     color: tokens.color.brand.onPrimary,
//     textTransform: "inherit",
//     borderRadius: tokens.radius.full,
//     boxShadow: "none",
//     textAlign: "center",
//     marginRight: "2%",
//     border: "1px solid #3C72D9",
//     // height: "15px",
//     padding: "8px",

//     // border: "1px solid #3C72D9",
//     "&:hover": {
//       backgroundColor: theme.palette.primary.main,
//       opacity: "0.8",
//     },
//     "&.Mui-disabled": {
//       backgroundColor: tokens.color.surface.subtle,
//       color: tokens.color.brand.onPrimary,
//     },
//   },
// }));

const useStyle = makeStyles((theme) => ({
  caseContainer: {
    // width: "928px",
    width: "98%",
    paddingLeft: "2%",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  topBar: {
    height: "50px",

    padding: "0 2% 0 2%",
    display: "flex",
    alignItems: "center",
  },
  heading: {
    fontSize: "1em",
    color: tokens.color.brand.primaryAction,
    //fontWeight: "bold",
  },
  parent: {
    justifyContent: "space-between",
    flexDirection: "row",
    flexWrap: "wrap",
    display: "flex",
    paddingRight: "2%",
    marginTop: "2vh",
  },
  parentChild: {
    flex: "1",
    width: "40%",
    "&:nth-child(1)": {
      paddingRight: "5vh",
    },
    "&:nth-child(2)": {
      paddingLeft: "5vh",
    },
  },
  rowContainer: {
    display: "flex",
    marginTop: "8px",
  },
  labelContainer: {
    display: "flex",
    width: "50%",
    alignItems: "center",
    "& p": {
      fontSize: "1em",
      // fontWeight:"bold",
      color: tokens.color.text.primary,
    },
  },
  fieldContainer: {
    width: "50%",
  },
  postButton: {
    height: "35px",
    fontSize: ".9em",
    marginTop: "20px",
    width: "160px",
    color: tokens.color.brand.onPrimary,
    backgroundColor: tokens.color.brand.primaryAction,
    //fontWeight: "bold",
    textTransform: "capitalize",
    // border: "1px solid #3C72D9",
    borderRadius: tokens.radius.md,
    "&:hover": {
      backgroundColor: tokens.color.brand.primaryAction,
      opacity: "0.8",
    },
    "&.Mui-disabled": {
      backgroundColor: tokens.color.surface.subtle,
      color: tokens.color.brand.onPrimary,
    },
  },
  input: {
    // width: "95%",
    border: `1px solid ${tokens.color.border.default}`,
    "& .MuiInputBase-input": {
      textIndent: "10px",
    },
    borderRadius: tokens.radius.sm,
    height: "40px",
    paddingLeft: "3px",
    backgroundColor: tokens.color.surface.sunken,
  },
  subjectButton: {
    // padding:"0.5vh 3vh 0.5vh 3vh",
    width: "160px",
    color: tokens.color.brand.onPrimary,
    //fontWeight: "bold",
    textTransform: "capitalize",
    backgroundColor: tokens.color.brand.primaryAction,
    // border: "1px solid #3C72D9",
    borderRadius: tokens.radius.sm,
    fontSize: "1.1em",
    "&:hover": {
      backgroundColor: tokens.color.brand.primaryAction,
      opacity: "0.8",
    },
  },
  buttonRow: {
    display: "flex",
    flexDirection: "row-reverse",
    columnGap: "15px",
    marginTop: "1vh",
  },
  buttonRowTabButton: {
    boxShadow: "none",
    backgroundColor: tokens.color.surface.sunken,
    borderRadius: tokens.radius.sm,
    textTransform: "capitalize",
  },

  invoiceDetailsTable: {
    width: "100%",
    textAlign: "left",
    color: tokens.color.text.primary,
    borderCollapse: "separate",
    borderSpacing: "0 0px",
    fontSize: "1em",
    // maxWidth:"fit-content",
    // overflow: "visible",
    // display: "block",
    // overflowX: "auto",
    whiteSpace: "nowrap",
  },
  headerStyle: {
    height: "40px",
  },
  rowHeaderStyle: {
    fontWeight: 600,
    color: tokens.color.text.secondary,
    paddingLeft: "5px",
    height: "40px",
    border: `1px solid ${tokens.color.border.default}`,
    borderRight: "0px !important",
    borderTop: "0px",
    "&:first-child": {
      borderLeft: "0px !important",
    },
  },
  tableTd: {
    height: "40px",
    paddingLeft: "16px",
    whiteSpace: "nowrap",
    border: `1px solid ${tokens.color.border.default}`,
    borderRight: "0px !important",
    borderTop: "0px",
    "&:first-child": {
      borderLeft: "0px !important",
    },
    "&:last-child": {
      borderRight: "0px !important",
    },
    "&:hover": {
      backgroundColor: tokens.color.surface.sunken,
    },
  },
  tableTh: {
    fontSize: "0.9em",
    fontWeight: 600,
    color: tokens.color.text.secondary,
    textAlign: "left",
    backgroundColor: tokens.color.surface.sunken,
    paddingLeft: "5px",
    whiteSpace: "pre-line !important",
    wordWrap: "break-word",
    border: `1px solid ${tokens.color.border.default}`,
    borderRight: "0px",
    "&:first-child": {
      borderTopLeftRadius: tokens.radius.sm,
      borderBottomLeftRadius: tokens.radius.sm,
    },
    "&:last-child": {
      borderRight: `1px solid ${tokens.color.border.default}`,
      borderTopRightRadius: tokens.radius.sm,
      borderBottomRightRadius: tokens.radius.sm,
    },
  },

  wrap: {
    // whiteSpace: "nowrap"
  },
  actionButton: {
    backgroundColor: theme.palette.primary.main,
    // fontFamily: "poppins",
    //fontWeight: "bold",
    fontSize: ".8em",
    color: tokens.color.brand.onPrimary,
    textTransform: "inherit",
    borderRadius: tokens.radius.full,
    boxShadow: "none",
    textAlign: "center",
    marginRight: "2%",
    border: `1px solid ${tokens.color.brand.primary}`,
    // height: "15px",
    padding: "8px",

    // border: "1px solid #3C72D9",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: "0.8",
    },
    "&.Mui-disabled": {
      backgroundColor: tokens.color.surface.subtle,
      color: tokens.color.brand.onPrimary,
    },
  },
  formikInput: {
    // color: theme.palette.primary.main,
    opacity: 1,
    color: `${tokens.color.text.primary} !important`,
    fontSize: "1em",
    textAlign: "right",
    "& .MuiInputBase-input": {
      textAlign: "left",
    },
    "& ::-webkit-calendar-picker-indicator": {
      marginLeft: "0px",
    },
  },
  formikInputPrimaryColor: {
    color: `${theme.palette.primary.main} !important`,
    opacity: 1,
    fontSize: "1em",
    textAlign: "left",
    "& .MuiInputBase-input": {
      textAlign: "left",
    },
    "& ::-webkit-calendar-picker-indicator": {
      marginLeft: "0px",
    },
  },
}));

function InvoiceDetailsTable({ values, index, setFieldValue }) {
  const classes = useStyle();

  // Extracting the keys for column headers
  const columnTitles = [
    { name: "Total Invoiced", key: "total_invoiced" },
    { name: "Retainer Credit", key: "retainer_credit" },
    { name: "Total Due", key: "total_due" },
    {
      name: "Final Report Sent",
      key: "final_report_sent",
    },
    {
      name: "Invoice Date",
      key: "invoice_date",
    },
    {
      name: "Paid Date",
      key: "paid_date",
    },
    {
      name: "Amount Paid",
      key: "amount_paid",
    },
    {
      name: "Check Number",
      key: "check_number",
    },
    {
      name: "Fee Waiver Amount",
      key: "fee_waiver_amount",
    },
    {
      name: "Amount Outstanding",
      key: "amount_outstanding",
    },
  ];

  // Use Effect for Total Invoiced
  useEffect(() => {
    let sum = 0.0;

    for (const key in values.invoices[index].invoice_breakdown) {
      var amount =
        values.invoices[index].invoice_breakdown[key]["quantity"] *
        values.invoices[index].invoice_breakdown[key]["rate"];
      sum += amount;
      setFieldValue(
        `invoices[${index}].invoice_breakdown[${key}].amount`,
        parseFloat(amount).toFixed(2)
      );
    }

    setFieldValue(
      `invoices[${index}].invoice_details.total_invoiced`,
      parseFloat(sum).toFixed(2)
    );
  }, [values.invoices[index].invoice_breakdown]);

  // Use Effect for Total Due
  useEffect(() => {
    setFieldValue(
      `invoices[${index}].invoice_details.total_due`,
      parseFloat(
        values.invoices[index].invoice_details.total_invoiced -
          values.invoices[index].invoice_details.retainer_credit
      ).toFixed(2)
    );
  }, [
    values.invoices[index].invoice_details.retainer_credit,
    values.invoices[index].invoice_details.total_invoiced,
  ]);

  // Use Effect for amount_outstanding
  useEffect(() => {
    setFieldValue(
      `invoices[${index}].invoice_details.amount_outstanding`,
      parseFloat(
        values.invoices[index].invoice_details.total_due -
          values.invoices[index].invoice_details.amount_paid -
          values.invoices[index].invoice_details.fee_waiver_amount
      ).toFixed(2)
    );
  }, [
    values.invoices[index].invoice_details.total_due,
    values.invoices[index].invoice_details.amount_paid,
    values.invoices[index].invoice_details.fee_waiver_amount,
  ]);

  return (
    <table className={classes.invoiceDetailsTable}>
      <thead>
        <tr className={classes.headerStyle}>
          {columnTitles.map((title, index) => (
            <th key={index} className={classes.tableTh}>
              {title.name}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <td className={classes.tableTd}>
          <Field
            name={`invoices[${index}].invoice_details.total_invoiced`}
            disabled={true}
            type={"number"}
            className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
            disableUnderline={true}
            component={FMUInputField}
          />
        </td>
        <td className={classes.tableTd}>
          <Field
            name={`invoices[${index}].invoice_details.retainer_credit`}
            type={"number"}
            className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
            disableUnderline={true}
            component={FMUInputField}
            onChange={(e) => {
              setFieldValue(
                `invoices[${index}].invoice_details.retainer_credit`,
                parseFloat(e.target.value).toFixed(2)
              );
            }}
          />
        </td>
        <td className={classes.tableTd}>
          <Field
            name={`invoices[${index}].invoice_details.total_due`}
            disabled={true}
            type={"number"}
            className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
            disableUnderline={true}
            component={FMUInputField}
          />
        </td>
        <td className={classes.tableTd}>
          <Field
            name={`invoices[${index}].invoice_details.final_report_sent`}
            disabled={true}
            type={"date"}
            className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
            disableUnderline={true}
            component={FMUInputField}
          />
        </td>
        <td className={classes.tableTd}>
          <Field
            name={`invoices[${index}].invoice_details.invoice_date`}
            disabled={true}
            type={"date"}
            className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
            disableUnderline={true}
            component={FMUInputField}
          />
        </td>
        <td className={classes.tableTd}>
          <Field
            name={`invoices[${index}].invoice_details.paid_date`}
            type={"date"}
            className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
            disableUnderline={true}
            component={FMUInputField}
          />
        </td>
        <td className={classes.tableTd}>
          <Field
            name={`invoices[${index}].invoice_details.amount_paid`}
            type={"number"}
            dollar={true}
            className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
            disableUnderline={true}
            component={FMUInputField}
            value={values.invoices[index].invoice_details.amount_paid}
            onChange={(e) => {
              setFieldValue(
                `invoices[${index}].invoice_details.amount_paid`,
                parseFloat(e.target.value).toFixed(2)
              );
            }}
          />
        </td>
        <td className={classes.tableTd}>
          <Field
            name={`invoices[${index}].invoice_details.check_number`}
            type={"text"}
            className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
            disableUnderline={true}
            component={FMUInputField}
          />
        </td>
        <td className={classes.tableTd}>
          <Field
            name={`invoices[${index}].invoice_details.fee_waiver_amount`}
            type={"number"}
            dollar={true}
            className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
            disableUnderline={true}
            component={FMUInputField}
            value={values.invoices[index].invoice_details.fee_waiver_amount}
            onChange={(e) => {
              setFieldValue(
                `invoices[${index}].invoice_details.fee_waiver_amount`,
                parseFloat(e.target.value).toFixed(2)
              );
            }}
          />
        </td>
        <td className={classes.tableTd}>
          <Field
            name={`invoices[${index}].invoice_details.amount_outstanding`}
            value={values.invoices[index].invoice_details.amount_outstanding}
            disabled={true}
            className={`${classes.formikInputPrimaryColor} ${classes.fieldPaddingRight}`}
            disableUnderline={true}
            type={"number"}
            dollar={true}
            component={FMUInputField}
          />
        </td>
      </tbody>
    </table>
  );
}

export default InvoiceDetailsTable;
